<template>
    <v-container grid-list-xs fluid>
        <v-card min-height="800px">
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>Load By Report Tool</h3>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="3">
                        <v-text-field
                            name="Start Time"
                            label="Start Time"
                                v-mask="'####-##-##'"
                                placeholder="YYYY-MM-DD"
                                v-model="$store.state.load.StartTime"

                        ></v-text-field>
                    </v-col>
                    
                    <v-col cols="3">
                        <v-text-field
                            name="Start Time"
                            label="End Time"
                                v-mask="'####-##-##'"
                                placeholder="YYYY-MM-DD"
                            v-model="$store.state.load.EndTime"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-container grid-list-xs>
                 <v-row>
                    <v-col v-for="itm in btn" :key="itm.id" cols="3" >
                        <v-btn block  @click="getBtn(itm)" large  color="primary">{{ itm.title }}</v-btn>
                    </v-col>
                 </v-row>
            </v-container>
        </v-card>   
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
export default {
    directives: { mask },
    data: function() {
        return {
            btn:[
                {id:2,title:'Truck', Url:'load-by/truck'},
                // {id:3,title:'Driver', Url:'load-by/truck'},
            ]
        };
    },
    mounthed(){

    },
    methods: {
        getBtn(itm){
            console.log(itm);
            this.$store.state.load.url = itm.Url;
            this.$store.state.load.title = itm.title;
                this.$router.push('/reports/report/load/by');
            
            
        }
    }
}
</script>